var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 161,
    height: 161,
    viewBox: "0 0 161 161",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0510254,
    y: 0.354492,
    width: 160,
    height: 160,
    rx: 2,
    fill: "#D9D9D9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80.051,
    cy: 52.3545,
    r: 28,
    fill: "#4D4D4D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.051 160.354C159.156 160.354 160.055 159.459 160.014 158.355C159.721 150.369 157.672 142.489 153.961 135.097C149.941 127.09 144.048 119.814 136.62 113.685C129.191 107.557 120.372 102.695 110.666 99.3784C100.96 96.0616 90.5568 94.3545 80.051 94.3545C69.5453 94.3545 59.1424 96.0616 49.4363 99.3784C39.7303 102.695 30.9112 107.557 23.4825 113.685C16.0538 119.814 10.161 127.09 6.14066 135.097C2.42973 142.489 0.381122 150.369 0.0877479 158.355C0.0471946 159.459 0.946456 160.354 2.05103 160.354L80.051 160.354H158.051Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.6bc3464b259552fdf009fbcecc38b40e.svg";
export { ForwardRef as ReactComponent };